import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
// eslint-disable-next-line td-wb-rules/uirouter-import-rule
import { UIRouterModule } from '@uirouter/angular';
import {
  ComponentsModule,
  PipesModule
} from '@tdwb/core';

import { PortfolioContactsRoutes } from './portfolio-contacts.routes';
import { PortfolioContactsComponent } from './portfolio-contacts.component';
import { PortfolioContactsRestService } from './portfolio-contacts.rest.service';

@NgModule({
  imports: [
    UIRouterModule.forChild({ states: PortfolioContactsRoutes.states }),
    TranslateModule.forChild(),
    CommonModule,
    ComponentsModule,
    PipesModule
  ],
  declarations: [
    PortfolioContactsComponent
  ],
  exports: [
    PortfolioContactsComponent
  ],
  providers: [
    PortfolioContactsRestService
  ]
})
export class PortfolioContactsModule {}

export {
  PortfolioContactsComponent
};
